// extracted by mini-css-extract-plugin
export default {"mobile":"style_mobile__hNSO0","open":"style_open__dIeNj","content":"style_content__X99GY","laptop":"style_laptop__dd+iO"};